import { Component, OnInit } from '@angular/core';
import { Animacao } from '../../core/tools/animacao';

/* Services */

import { ListenerService } from '../../core/services/listener/listener.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css'],
    preserveWhitespaces: false,
    animations: [Animacao],
    standalone: false
})

export class LoaderComponent implements OnInit {
  carregando: boolean = false;
  mensagem: string = "";

  constructor(
    private listenerService: ListenerService
  ) {
    this.listenerService.verificarRequisicoesPendentes().subscribe(pendente => {
      this.carregando = pendente;
    });

    this.listenerService.verificarMensagemLoader().subscribe(mensagem => {
      this.mensagem = mensagem;
    });
  }

  ngOnInit() {

  }
}
